import React, { useContext } from "react";
import { CommandBarButton, Stack, TooltipHost, useDisclosure } from "sprint-common-web";

import { isInvalidStatusForQcDone } from "../../common/types/CloudFileStatus";
import { CloudFileDashboardContext } from "../common/context/CloudFileDashboardContext";
import { useCloudFileDetails } from "../common/useCloudFileDetails";
import { inactiveContentMessage } from "../sections/associate/utils/checkIsInactiveContentSelected";
import { QcDoneStatusDialog } from "../sections/info/QcDoneStatusDialog";

export const CloudFileQcDoneButton = (): JSX.Element => {
    const { areUnsavedChanges, lookupFileRecordId, isInactiveContentSelected, isAssociateFormReady } = useContext(
        CloudFileDashboardContext
    );
    const { isOpen, onClose, onOpen } = useDisclosure();

    const { data: cloudFileDetails } = useCloudFileDetails();

    if (!cloudFileDetails) {
        return <></>;
    }

    const getTooltipContent = (): string => {
        if (isInactiveContentSelected) {
            return inactiveContentMessage;
        }

        return areUnsavedChanges ? "Form has unsaved changes." : "";
    };

    const isActionDisabled =
        isInvalidStatusForQcDone(cloudFileDetails.status) ||
        areUnsavedChanges ||
        isInactiveContentSelected ||
        !isAssociateFormReady;

    return (
        <Stack>
            <TooltipHost styles={{ root: { display: "flex" } }} content={getTooltipContent()}>
                <CommandBarButton
                    testId="cloud-file-qc-done-button"
                    onClick={onOpen}
                    text="Qc Done"
                    icon="ActivateOrders"
                    disabled={isActionDisabled}
                />
                <QcDoneStatusDialog
                    isOpen={isOpen}
                    onClose={onClose}
                    fileRecordId={lookupFileRecordId}
                    cloudFileId={cloudFileDetails?.cloudFileId}
                    cloudFileRecordType={cloudFileDetails?.recordType}
                />
            </TooltipHost>
        </Stack>
    );
};
